import type { PaymentTaxesTranslations } from "../interfaces/paymentTaxes";

export const paymentTaxesTranslations: PaymentTaxesTranslations = {
  // Page
  page_title: "Impostos",
  page_subtitle:
    "IVA, 4x1000 ou qualquer imposto por país, corredor a corredor: sobre a comissão ou sobre o valor, quem paga e quais organizações pagam diferente",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar impostos",
  new_tax_button: "Novo imposto",
  why_banner:
    "Os impostos que o cliente paga são somados ao que é cobrado dele, como a comissão; os que a Coloca assume não mudam os valores. Cotações e lotes já validados mantêm o imposto com que foram calculados.",
  truncated_notice: "Há mais versões do que as carregadas; o que é mostrado pode estar incompleto.",
  error_load: "Não foi possível carregar os impostos",
  error_load_detail: "Verifique sua conexão e tente novamente.",
  error_retry: "Tentar novamente",
  empty_title: "Ainda não há impostos",
  empty_description: "Crie o primeiro, por exemplo o IVA sobre a comissão ou o 4x1000 sobre o valor.",
  empty_org_title: "Sem impostos para esta organização",
  empty_org_description: "Nenhum imposto geral ou próprio se aplica a esta organização.",

  // Scope selector
  scope_label: "Escopo",
  scope_placeholder: "Buscar por nome, e-mail ou ID…",
  scope_loading: "Carregando organizações…",
  scope_empty: "Nenhuma organização encontrada.",
  scope_searching: "Buscando organizações…",
  scope_search_error: "Não foi possível concluir a busca; mostrando as organizações já carregadas.",
  scope_global_option: "Geral (todas as organizações)",
  scope_global_hint: "Impostos gerais: o que paga qualquer organização sem tarifa própria.",
  scope_org_hint:
    "O que esta organização paga. As mudanças aqui criam sua tarifa própria, que vale sobre a geral.",
  scope_catalog_error:
    "Não foi possível carregar o catálogo de organizações; algumas podem mostrar o ID em vez do nome.",
  scope_catalog_truncated: "Há mais organizações do que as listadas; digite para buscar todas.",

  // Rows
  base_commission: "Sobre a comissão",
  base_gross: "Sobre o valor",
  bearer_client: "Pago pelo cliente",
  bearer_coloca: "Assumido pela Coloca",
  bearer_client_hint: "Somado ao que o cliente paga, igual à comissão.",
  bearer_coloca_hint: "O cliente não vê nenhuma mudança; a Coloca registra como despesa.",
  where_all: "Cobranças e envios",
  where_payin: "Só cobranças",
  where_payout: "Só envios",
  where_any_rail: "todos os trilhos",
  exempt: "Isenta",
  source_general: "Geral",
  source_own: "Própria",
  inherited_from: "Pela tarifa própria de {{where}}",
  exceptions_count: "Exceções: {{count}}",
  scheduled: "Mudança programada",
  since: "Desde {{date}}",
  example_commission: "Comissão {{amount}}",
  example_gross: "Valor {{amount}}",
  example_tax_fallback: "Imposto",
  actions_aria: "Ações de {{name}}",
  action_change: "Alterar tarifa",
  action_change_special: "Alterar tarifa própria",
  action_special: "Dar tarifa própria",
  action_special_here: "Tarifa própria só aqui",
  action_exempt: "Isentar",
  action_back_general: "Voltar à geral",
  action_history: "Ver histórico",

  // Dialog
  dialog_title_new: "Novo imposto",
  dialog_title_change: "Alterar {{name}}",
  dialog_title_special: "Tarifa própria de {{name}}",
  dialog_scope_general: "Aplica-se a todas as organizações sem tarifa própria.",
  dialog_scope_org: "Só para {{org}}.",
  field_country: "País",
  field_code: "Código",
  field_code_hint: "De 2 a 8 letras ou números, por exemplo IVA ou GMF. Agrupa as versões do imposto.",
  field_name: "Nome",
  field_name_hint: "O que clientes e operações leem, por exemplo IVA ou 4x1000.",
  field_base: "Calculado",
  field_base_locked: "A base de um imposto não muda entre versões.",
  field_rate: "Tarifa",
  field_rate_hint: "Porcentagem da comissão da Coloca. 0 isenta o escopo.",
  field_rate_gross_hint:
    "Porcentagem do valor: na cobrança, o que o pagador envia; no envio, o que a pessoa recebe. Máximo 10 %.",
  field_bearer: "Quem paga",
  field_direction: "Aplica-se a",
  field_rail: "Trilho",
  field_rail_any: "Qualquer trilho",
  eff_now_label: "Vale a partir de agora",
  eff_date_label: "A partir do dia",
  eff_time_label: "Hora",
  reason_label: "Motivo",
  reason_placeholder: "Por exemplo: resolução fiscal, acordo com o cliente…",
  reason_hint: "Interno: fica no histórico e no alerta da mudança.",
  review_title: "Revise a mudança",
  review_before: "Hoje",
  review_after: "Com a mudança",
  review_none: "Sem imposto",
  review_affects:
    "Afeta todas as organizações sem tarifa própria de {{name}} em {{country}}, a partir da data indicada.",
  review_ack: "Entendo que isso muda o que os clientes pagam a partir dessa data.",
  button_cancel: "Cancelar",
  button_back: "Voltar",
  button_review: "Revisar",
  button_save: "Salvar",
  validation_code: "Use de 2 a 8 letras ou números, sem espaços.",
  validation_name: "Escreva um nome de até 64 caracteres.",
  validation_rate: "Escreva uma porcentagem entre 0 e 100, com até 4 decimais.",
  validation_rate_gross: "Sobre o valor total o máximo é 10%.",
  validation_valid_from: "Escolha a partir de que dia vale.",
  validation_reason: "Escreva o motivo da mudança.",
  validation_ack: "Confirme que revisou a mudança.",

  // Exemptions
  exempt_title: "Isentar de {{name}}",
  exempt_description:
    "{{org}} deixa de pagar {{name}} em {{where}} a partir de agora. Operações já feitas e cotações vigentes não mudam.",
  exempt_confirm: "Isentar",
  back_general_title: "Voltar à tarifa geral de {{name}}",
  back_general_description:
    "As versões próprias de {{org}} para {{name}} em {{where}} são excluídas; a partir de agora paga a tarifa geral.",
  back_general_confirm: "Voltar à geral",
  back_general_affects: "Esta regra também vale para: {{rows}}. Todas voltam à tarifa geral.",

  // History
  history_title: "Histórico de {{name}}",
  history_description: "Cada versão deste escopo, da mais recente à mais antiga.",
  history_scope_general: "Tarifa geral · {{where}}. Toda organização sem tarifa própria a paga.",
  history_scope_own: "Tarifa própria de {{org}} · {{where}}.",
  history_scope_covers: "Esta regra vale para: {{rows}}. Excluir uma versão muda todas.",
  history_read_only_general: "Somente leitura: a tarifa geral se corrige sem organização escolhida.",
  history_read_only_inherited: "Somente leitura: esta regra se corrige na sua própria linha.",
  history_version: "Versão {{version}}",
  history_in_force: "Vigente",
  history_scheduled: "Programada",
  history_superseded: "Substituída",
  history_reason_none: "Sem motivo",
  history_delete: "Corrigir: excluir esta versão",
  history_delete_description:
    "A versão anterior volta a valer. Para deixar de cobrar o imposto, salve uma versão em 0%.",
  history_delete_confirm: "Excluir versão",

  // Feedback
  toast_saved: "{{name}} salvo",
  toast_deleted: "Versão excluída",
  toast_exempted: "{{org}} ficou isenta de {{name}}",
  toast_back_general: "{{org}} volta à tarifa geral de {{name}}",
  error_save: "Não foi possível salvar o imposto.",
  error_delete: "Não foi possível excluir a versão.",
  error_no_write_permission: "Você não tem permissão para alterar impostos.",

  // Corridors view
  tab_corridors: "Corredores",
  tab_history: "Histórico de mudanças",
  tab_rules: "Regras",
  tab_intro_corridors:
    "Cada corredor com os impostos que cobra hoje, calculados sobre o valor de exemplo. Edite-os na sua linha.",
  tab_intro_history:
    "Cada mudança de um imposto, a mais recente primeiro: quem fez, o que havia antes e por quê.",
  tab_intro_rules:
    "As regras de cada país com suas versões. Aqui se cria um imposto novo e se corrige uma versão.",
  guide_title: "Como funcionam os impostos",
  guide_base_title: "Sobre o que se calcula",
  guide_base_body:
    "Sobre a comissão da Coloca (o IVA) ou sobre o valor (o 4x1000). Num envio, o valor é o que a pessoa recebe; numa cobrança, o que o pagador envia.",
  guide_bearer_title: "Quem paga",
  guide_bearer_body:
    "O cliente, somado ao que lhe é cobrado como a comissão; ou a Coloca, e o cliente não vê mudança.",
  guide_scope_title: "Onde se aplica",
  guide_scope_body:
    "Sempre no país do corredor. Uma regra pode cobrir o país todo ou só um trilho ou uma direção; a mais específica vence.",
  guide_own_title: "Tarifa própria",
  guide_own_body:
    "Escolha uma organização acima para ver o que ela paga. A tarifa própria vence a geral; em 0 % fica isenta.",
  guide_changes_title: "Mudanças",
  guide_changes_body:
    "Cada mudança é uma versão nova com data; nada é reescrito. Cotações vigentes mantêm o imposto com que foram calculadas.",
  guide_untaxed_title: "O que não paga",
  guide_untaxed_body: "Operações em USDT nunca levam impostos. Um corredor sem impostos cobra só a comissão.",
  banner_general_title: "Impostos gerais",
  banner_general_body: "Toda organização sem tarifa própria os paga. O que você mudar aqui vale para todas.",
  banner_general_orgs: "Organizações com tarifa própria em algum corredor: {{count}}",
  banner_org_title: "Impostos de {{name}}",
  banner_org_body: "O que {{name}} paga. O que você mudar aqui vale só para {{name}}.",
  banner_back_to_general: "Ver os gerais",
  kpi_all_label: "Corredores",
  kpi_all_meta: "{{taxed}} com impostos",
  kpi_unavailable: "Sem catálogo de corredores",
  kpi_taxed_label: "Com impostos",
  kpi_taxed_meta: "Cobram ao menos um imposto",
  kpi_own_label: "Com tarifa própria",
  kpi_own_meta_general: "Alguma organização paga diferente",
  kpi_own_meta_org: "Onde esta organização paga diferente",
  kpi_scheduled_label: "Mudanças programadas",
  kpi_scheduled_meta: "Uma versão começa mais adiante",
  corridors_th_corridor: "Corredor",
  corridors_th_taxes_general: "Impostos gerais",
  corridors_th_taxes_org: "Impostos desta organização",
  corridors_th_own: "Tarifa própria",
  corridors_th_client: "Paga o cliente",
  corridors_th_coloca: "A Coloca assume",
  routes_error: "Não conseguimos carregar os corredores",
  routes_error_detail: "Sem o catálogo de corredores não dá para mostrar quais impostos cada um cobra.",
  corridors_empty_title: "Não há corredores",
  corridors_empty_description: "Um corredor aparece aqui com seus impostos quando tiver rota.",
  corridors_filtered_empty_title: "Nenhum corredor corresponde",
  corridors_filtered_empty_description: "Escolha outro cartão acima para ver mais corredores.",
  taxes_none: "Sem impostos",
  commission_unknown: "sem comissão configurada",
  source_general_baseline: "Geral: {{rate}}",
  source_no_general: "Sem imposto geral",
  own_none: "Nenhuma",
  own_count: "Organizações: {{count}}",
  own_popover_title: "Organizações com tarifa própria",
  own_popover_hint: "Escolha uma para ver e editar o que ela paga.",
  action_edit_taxes: "Editar impostos",
  action_view_rules: "Ver regras",
  action_more_aria: "Mais ações de {{corridor}}",
  edit_title_general: "Editar impostos",
  edit_title_own: "Tarifa própria de {{name}}",
  edit_applies_general: "Vale para toda organização sem tarifa própria",
  edit_applies_own: "Vale só para {{name}}",
  edit_no_taxes_title: "{{country}} não tem impostos",
  edit_no_taxes_description:
    "Crie o imposto primeiro, por exemplo o IVA sobre a comissão; depois ele é editado em cada corredor.",
  edit_tax_label: "Imposto",
  edit_target_label: "Onde a mudança é salva",
  edit_target_broad: "Na regra que este corredor segue: {{where}} (corredores: {{count}})",
  edit_target_corridor: "Só neste corredor",
  edit_exempt: "Isenta (0 %)",
  edit_valid_from: "Vale a partir de {{date}}",
  edit_collision:
    "Já existe uma versão desta regra que começa nesse mesmo momento. Escolha outra data ou hora.",
  edit_compare_title: "Hoje vs. com a mudança",
  edit_compare_amount: "Sobre {{amount}}",
  review_intro: "Corredores que mudam: {{count}}. Valores sobre o valor de exemplo de cada um.",
  review_orgs_kept: "Estas organizações têm tarifa própria e não mudam ({{count}}):",
  review_orgs_none: "Nenhuma organização tem tarifa própria nestes corredores.",
  remove_title: "Voltar aos impostos gerais",
  remove_description:
    "{{name}} deixa sua tarifa própria em {{corridor}} e paga os impostos gerais a partir de agora.",
  remove_broad_note: "Esta tarifa própria cobre vários corredores ({{count}}) e todos voltam à geral:",
  remove_after_title: "Depois da mudança",
  remove_after_none: "Sem imposto",
  remove_versions_title: "Versões excluídas",
  history_drawer_title: "Histórico de {{corridor}}",
  history_drawer_desc_general: "As mudanças dos impostos gerais deste corredor.",
  history_drawer_desc_org: "As mudanças que alcançam {{name}} neste corredor: gerais e próprias.",
  history_empty: "Ainda não há mudanças",
  history_deleted_note: "Versões excluídas como correção não aparecem aqui.",
  history_role_own: "Própria de {{name}}",
  history_unknown_author: "autor desconhecido",
  history_new: "Nova",
  period_starts: "Começa em {{from}}",
  period_open: "Desde {{from}}",
  period_range: "{{from}} → {{to}}",
  feed_today: "Hoje",
  feed_yesterday: "Ontem",
  feed_filter_source: "Tipo de regra",
  feed_source_all: "Todas",
  feed_source_general: "Gerais",
  feed_source_own: "Próprias",
  feed_count: "Mudanças: {{count}}",
  feed_empty_title: "Sem mudanças",
  feed_empty_description: "Quando alguém criar ou mudar um imposto, aparecerá aqui.",
  feed_load_more: "Ver mais",
  toast_scheduled: "{{name}} salvo; vale a partir de {{date}}",
  toast_removed: "{{name}} volta aos impostos gerais",
};
